export interface SliderRange {
  min: number;
  max: number;
  step?: number;
}

export enum SliderEvents {
  CHANGE = 'change',
}

export interface SliderTranslateStrings {
  fromLabel: string;
  toLabel: string;
}
